import { Group, Stack, Text } from "@assetwatch/ui";
import { DetailCard, formatDate } from "./WorkOrderDetailLayout";
import {
  CHANGE_FIELD_LABELS,
  displayChangeValue,
} from "./workOrderHistoryFormat";

type WorkOrderHistoryEvent = {
  eventType: { code: string; name: string };
  occurredOn: string;
  actor: string;
  related: string | null;
  changes: Array<{ field: string; from: string; to: string }>;
};

export function HistorySection({
  history,
}: {
  history: WorkOrderHistoryEvent[];
}) {
  return (
    <DetailCard id="history" title="History">
      {history.length === 0 ? (
        <div className="px-(--spacing-20) py-(--spacing-20)">
          <Text tone="subtle">No history events have been recorded.</Text>
        </div>
      ) : (
        <div className="divide-y divide-outline-subtle">
          {history.map((event, index) => (
            <div
              className="px-(--spacing-20) py-(--spacing-16)"
              key={`${event.occurredOn}:${event.eventType.code}:${index}`}
            >
              <Group align="start" justify="between" wrap="wrap">
                <Stack gap={4}>
                  <Text>{event.eventType.name}</Text>
                  <Text size="sm" tone="subtle">
                    {event.actor} · {formatDate(event.occurredOn)}
                    {event.related ? ` · ${event.related}` : ""}
                  </Text>
                </Stack>
              </Group>
              {event.changes.length > 0 ? (
                <Stack gap={4}>
                  {event.changes.map((change) => (
                    <Text key={change.field} size="sm">
                      {CHANGE_FIELD_LABELS[change.field] ?? change.field}:{" "}
                      {displayChangeValue(change, change.from)} →{" "}
                      {displayChangeValue(change, change.to)}
                    </Text>
                  ))}
                </Stack>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </DetailCard>
  );
}
